Librarian.Modules.OpenFile = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-openfile-",
        onClick: null,
        label: null,
        filename: null,
    },

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
        var self = this;

        this.options.onClick = function () {
            Librarian.Modules.OpenFile.openFile(self.options.filename);
        };

        wrapperEl.addOnClick(this.options.onClick);
    },

    load: function () {
        this.parent();

        this.wrapperEl.addClass("nav-wrapper");
        var label = (this.options.label || '').trim();
        if (label.length > 0) {
            new Element("div", {
                "class": "nav-label",
                "html": label
            }).injectInside(this.containerEl);
        }
    }
});

Librarian.Modules.OpenFile.extend({
    openFile: function (filename, fvname, vname, contextInfo) {
        Librarian.Utils.getFileID(filename, function (fileId) {
            var url = Librarian.path.getMethodUrl("getslides") + "&fid=" + fileId + "&out=dgrid";

            if (fvname)
                url += "&fvname=" + fvname;

            if (vname)
                url += "&vname=" + vname;

            new Librarian.Request.JSON({
                url: url,
                onSuccess: function (json) {
                    Librarian.PreviewWindow.openPreviewWindow(json.data[0].fileinfo, null, null, contextInfo);
                }.bind(this)
            }).send();
        });
    }
})